(function () {
  'use strict';

  var I18N = window.casifyI18n || {};

  // ── Description: 'Meer lezen' toggle on mobile ────────────────────────────
  // Only shown when the (clamped) description actually overflows. JS measures
  // scrollHeight vs clientHeight; on resize we re-measure so rotating phone
  // or going desktop -> mobile re-evaluates correctly.
  (function () {
    var desc = document.querySelector('.collection-template__desc');
    var btn  = document.querySelector('.collection-template__desc-toggle');
    if (!desc || !btn) return;

    function recompute() {
      // Reset expanded state before measuring
      desc.classList.remove('is-expanded');
      btn.classList.remove('is-expanded', 'is-visible');
      btn.setAttribute('aria-expanded', 'false');
      if (window.innerWidth >= 768) {
        btn.hidden = true;
        return;
      }
      // overflow check (small tolerance for sub-pixel rounding)
      var overflows = desc.scrollHeight > desc.clientHeight + 1;
      btn.hidden = !overflows;
      if (overflows) btn.classList.add('is-visible');
    }

    btn.addEventListener('click', function () {
      var expanded = desc.classList.toggle('is-expanded');
      btn.classList.toggle('is-expanded', expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });

    recompute();
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(recompute, 120);
    });
  })();

  // ── Bootstrap ─────────────────────────────────────────────────────────────
  var wrapper = document.querySelector('.collection-template[data-collection-url]');
  if (!wrapper) return;

  var collectionUrl = wrapper.dataset.collectionUrl;

  // Parse active tags from URL pathname — this is the source of truth.
  // Shopify's collection.current_tags can be empty even when the URL has
  // tag filters (especially with ?sort_by=), so we never trust the Liquid
  // value alone.  Pattern: /collections/{handle}/{tag1}+{tag2}
  function parseTagsFromUrl() {
    var m = window.location.pathname.match(/\/collections\/[^/]+\/([^/?]+)/);
    if (!m) return [];
    return decodeURIComponent(m[1]).split('+').filter(Boolean);
  }

  var urlTags    = parseTagsFromUrl();
  var liquidTags = wrapper.dataset.activeTags
    ? wrapper.dataset.activeTags.split(',').filter(Boolean)
    : [];
  // URL is canonical; fall back to Liquid value only when URL has none
  var activeTags  = urlTags.length > 0 ? urlTags : liquidTags;
  var currentSort = wrapper.dataset.sort || new URLSearchParams(window.location.search).get('sort_by') || 'manual';

  // ── URL builder ───────────────────────────────────────────────────────────
  function buildUrl(tags, sort) {
    var path = collectionUrl;
    if (tags.length > 0) path += '/' + tags.join('+');
    var s = sort !== undefined ? sort : currentSort;
    return path + (s && s !== 'manual' ? '?sort_by=' + s : '');
  }

  function navigate(tags, sort) {
    window.location.href = buildUrl(tags, sort);
  }

  // ── Label helpers ─────────────────────────────────────────────────────────
  var COLOR_LABELS = I18N.colorLabels || {};
  var TYPE_LABELS = I18N.typeLabels || {};

  // Sub-variant → primary tag mapping
  // Display shows only the primary; clicking navigates with the primary tag.
  // NOTE: re-import the CSV with normalized tags so all products are found correctly.
  var COLOR_GROUP_MAP = {
    'kleur-donkerblauw': 'kleur-blauw',
    'kleur-lichtblauw':  'kleur-blauw',
    'kleur-marineblauw': 'kleur-blauw',
    'kleur-bosgroen':    'kleur-groen',
    'kleur-legergroen':  'kleur-groen',
    'kleur-donkergroen': 'kleur-groen',
    'kleur-donkerpaars': 'kleur-paars',
    'kleur-lichtpaars':  'kleur-paars',
  };

  // Representative swatch hex per merged colour group — so the single swatch
  // shown for a grouped colour is consistent regardless of which sub-variant
  // tag happens to come first in the list.
  var COLOR_GROUP_HEX = {
    'kleur-blauw':  '#4A6E94',
    'kleur-groen':  '#4A7359',
    'kleur-paars':  '#544A67',
  };

  function tagToModelLabel(tag) {
    var words = tag.replace(/^model-/, '').split('-');
    return words.map(function (w) {
      if (w === 'iphone') return 'iPhone';
      if (w === 'se')     return 'SE';
      if (w === 'air')    return 'Air';
      if (!isNaN(w))      return w;
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function tagToLabel(tag) {
    if (tag.indexOf('kleur-') === 0) {
      var primary = COLOR_GROUP_MAP[tag] || tag;
      return COLOR_LABELS[primary] || (primary.replace('kleur-', '').charAt(0).toUpperCase() + primary.replace('kleur-', '').slice(1));
    }
    if (tag.indexOf('type-') === 0) {
      if (TYPE_LABELS[tag]) return TYPE_LABELS[tag];
      return tag.replace('type-', '').split('-').map(function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      }).join(' ');
    }
    if (tag.indexOf('model-') === 0) return tagToModelLabel(tag);
    return tag;
  }

  // ── Panel helpers ─────────────────────────────────────────────────────────
  function closeAllPanels() {
    document.querySelectorAll('.cfilter__panel.is-open').forEach(function (p) {
      p.classList.remove('is-open');
    });
    document.querySelectorAll('.cfilter__trigger[aria-expanded="true"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }

  // ── Normalize colour panel (deduplicate sub-variants) ─────────────────────
  function normalizeColorPanel(panel) {
    var seen   = {};   // primaryTag → true (first occurrence kept)
    var opts   = Array.prototype.slice.call(panel.querySelectorAll('.cfilter__option'));

    opts.forEach(function (opt) {
      var tag     = opt.dataset.tag;
      var primary = COLOR_GROUP_MAP[tag] || tag;

      if (seen[primary]) {
        // Duplicate sub-variant — remove from DOM
        opt.parentNode.removeChild(opt);
      } else {
        seen[primary] = true;
        // Redirect click tag to the primary tag so all sub-variants are grouped under one filter
        opt.dataset.tag = primary;
        // Fix display label — always show the primary colour name (e.g. "Groen" not "Bosgroen").
        // IMPORTANT: target the TEXT span only (last element inside the label wrapper).
        // The wrapper's first child is the colour swatch — setting textContent on the
        // wrapper itself would wipe the swatch out of the DOM.
        var labelWrap = opt.querySelector('.cfilter__option-label');
        var label = COLOR_LABELS[primary] || (primary.replace('kleur-', '').charAt(0).toUpperCase() + primary.replace('kleur-', '').slice(1));
        if (labelWrap) {
          var textSpan = labelWrap.lastElementChild;
          if (textSpan) textSpan.textContent = label;
          // For merged groups, normalise the swatch to the group's representative hex
          var groupHex = COLOR_GROUP_HEX[primary];
          if (groupHex) {
            var sw = labelWrap.querySelector('.cfilter__swatch');
            if (sw && sw.className.indexOf('cfilter__swatch--transparent') === -1) {
              sw.style.backgroundColor = groupHex;
            }
          }
        }
        // Fix active state: active if primary OR any sub-variant is in activeTags
        var subTags = [primary].concat(
          Object.keys(COLOR_GROUP_MAP).filter(function (k) { return COLOR_GROUP_MAP[k] === primary; })
        );
        var isActive = subTags.some(function (t) { return activeTags.indexOf(t) !== -1; });
        if (isActive) {
          opt.classList.add('is-active');
          opt.setAttribute('aria-selected', 'true');
        } else {
          opt.classList.remove('is-active');
          opt.setAttribute('aria-selected', 'false');
        }
      }
    });
  }

  // ── Init filter groups ────────────────────────────────────────────────────
  document.querySelectorAll('.cfilter[data-filter-group]').forEach(function (group) {
    var trigger = group.querySelector('.cfilter__trigger');
    var panel   = group.querySelector('.cfilter__panel');
    var prefix  = group.dataset.filterGroup + '-';

    // Normalize colour panel to merge sub-variants
    if (group.dataset.filterGroup === 'kleur') {
      normalizeColorPanel(panel);
    }

    // Update trigger label + badge to reflect active state
    var activeInGroup = activeTags.filter(function (t) {
      var primary = COLOR_GROUP_MAP[t] || t;
      return primary.indexOf(prefix) === 0;
    });

    // Apply is-active state CLIENT-SIDE (Liquid's collection.current_tags
    // may be empty even when URL has tags — we trust the URL).
    if (activeInGroup.length > 0) {
      trigger.classList.add('is-active');
    }
    panel.querySelectorAll('.cfilter__option').forEach(function (opt) {
      var optTag = opt.dataset.tag;
      var optSubTags = [optTag].concat(
        Object.keys(COLOR_GROUP_MAP).filter(function (k) { return COLOR_GROUP_MAP[k] === optTag; })
      );
      var isActive = optSubTags.some(function (t) { return activeTags.indexOf(t) !== -1; });
      if (isActive) {
        opt.classList.add('is-active');
        opt.setAttribute('aria-selected', 'true');
      } else {
        opt.classList.remove('is-active');
        opt.setAttribute('aria-selected', 'false');
      }
    });

    var textEl = trigger.querySelector('.cfilter__trigger-text');
    if (activeInGroup.length >= 1) {
      // Show selected value in label; add a count badge if multiple
      textEl.textContent = tagToLabel(activeInGroup[0]);
      if (activeInGroup.length > 1) {
        var badge = document.createElement('span');
        badge.className = 'cfilter__badge';
        badge.textContent = '+' + (activeInGroup.length - 1);
        trigger.insertBefore(badge, trigger.querySelector('.cfilter__chevron'));
      }
    }

    // Open / close panel
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = panel.classList.contains('is-open');
      closeAllPanels();
      if (!isOpen) {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        // Scroll active option into view so user can see + click to deselect
        var activeOpt = panel.querySelector('.cfilter__option.is-active');
        if (activeOpt) {
          setTimeout(function () { activeOpt.scrollIntoView({ block: 'nearest' }); }, 20);
        }
      }
    });

    // Option click → toggle tag → navigate immediately
    panel.addEventListener('click', function (e) {
      var opt = e.target.closest('.cfilter__option');
      if (!opt) return;
      e.stopPropagation();

      var tag  = opt.dataset.tag;
      var idx  = activeTags.indexOf(tag);

      // Also check sub-variants of this tag
      var subTags = [tag].concat(
        Object.keys(COLOR_GROUP_MAP).filter(function (k) { return COLOR_GROUP_MAP[k] === tag; })
      );
      // Remove any currently active tag that belongs to this group/primary
      var next = activeTags.filter(function (t) {
        return subTags.indexOf(t) === -1;
      });

      // If wasn't active → add it; if was active → leave removed (deselect)
      var wasActive = subTags.some(function (t) { return activeTags.indexOf(t) !== -1; });
      if (!wasActive) next.push(tag);

      navigate(next);
    });
  });

  // Close panels on outside click or Escape
  document.addEventListener('click', closeAllPanels);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
  });

  // ── Sort dropdown (custom, mirrors filter dropdowns) ──────────────────────
  var sortGroup = document.querySelector('[data-sort-group]');
  if (sortGroup) {
    var sortTrigger = sortGroup.querySelector('.cfilter__trigger');
    var sortPanel   = sortGroup.querySelector('.cfilter__panel');

    sortTrigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = sortPanel.classList.contains('is-open');
      closeAllPanels();
      if (!isOpen) {
        sortPanel.classList.add('is-open');
        sortTrigger.setAttribute('aria-expanded', 'true');
      }
    });

    sortPanel.addEventListener('click', function (e) {
      var opt = e.target.closest('.cfilter__option');
      if (!opt) return;
      e.stopPropagation();
      navigate(activeTags, opt.dataset.sort);
    });
  }

  // ── Active filter chips ───────────────────────────────────────────────────
  function renderChips() {
    var container = document.getElementById('collection-active-filters');
    if (!container) return;
    container.innerHTML = '';
    if (activeTags.length === 0) return;

    activeTags.forEach(function (tag) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'collection-filters__chip';
      chip.setAttribute('aria-label', (I18N.removeFilter || 'Remove __LABEL__').replace('__LABEL__', tagToLabel(tag)));
      chip.innerHTML =
        '<span>' + tagToLabel(tag) + '</span>' +
        '<span class="collection-filters__chip-x" aria-hidden="true">&times;</span>';
      chip.addEventListener('click', function () {
        // Remove this tag and any sub-variants
        var primary = COLOR_GROUP_MAP[tag] || tag;
        var subTags = [tag, primary].concat(
          Object.keys(COLOR_GROUP_MAP).filter(function (k) { return COLOR_GROUP_MAP[k] === primary; })
        );
        navigate(activeTags.filter(function (t) { return subTags.indexOf(t) === -1; }));
      });
      container.appendChild(chip);
    });

    var clearAll = document.createElement('a');
    clearAll.href      = buildUrl([], currentSort);
    clearAll.className = 'collection-filters__clear-all';
    clearAll.textContent = I18N.clearAllFilters || 'Wis alle filters';
    container.appendChild(clearAll);
  }

  renderChips();

  // ── Model panel — sort by canonical iPhone order ──────────────────────────
  var MODEL_ORDER = [
    'iPhone 18 Pro Max', 'iPhone 18 Pro',
    'iPhone Air',
    'iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone 17', 'iPhone 17e',
    'iPhone 16 Pro Max', 'iPhone 16 Pro', 'iPhone 16 Plus', 'iPhone 16', 'iPhone 16e',
    'iPhone 15 Pro Max', 'iPhone 15 Pro', 'iPhone 15 Plus', 'iPhone 15',
    'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
    'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13 Mini', 'iPhone 13',
    'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12 Mini', 'iPhone 12',
    'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11',
    'iPhone 8', 'iPhone SE 2022', 'iPhone SE 2020'
  ];

  var modelGroup = document.querySelector('.cfilter[data-filter-group="model"]');
  if (modelGroup) {
    var modelPanel = modelGroup.querySelector('.cfilter__panel');
    var opts = Array.prototype.slice.call(modelPanel.querySelectorAll('.cfilter__option'));

    opts.forEach(function (opt) {
      opt.querySelector('span').textContent = tagToModelLabel(opt.dataset.tag);
    });

    opts.sort(function (a, b) {
      var ai = MODEL_ORDER.indexOf(a.querySelector('span').textContent);
      var bi = MODEL_ORDER.indexOf(b.querySelector('span').textContent);
      if (ai === -1) ai = MODEL_ORDER.length;
      if (bi === -1) bi = MODEL_ORDER.length;
      return ai - bi;
    });

    opts.forEach(function (opt) { modelPanel.appendChild(opt); });
  }

  // ── Type panel — fix labels (title-case, dashes → spaces) ────────────────
  var typeGroup = document.querySelector('.cfilter[data-filter-group="type"]');
  if (typeGroup) {
    var typePanel = typeGroup.querySelector('.cfilter__panel');
    Array.prototype.slice.call(typePanel.querySelectorAll('.cfilter__option')).forEach(function (opt) {
      opt.querySelector('span').textContent = tagToLabel(opt.dataset.tag);
    });
  }

})();
